import { render, staticRenderFns } from "./grossMarginList.vue?vue&type=template&id=3f17a92e&scoped=true"
import script from "./grossMarginList.vue?vue&type=script&lang=js"
export * from "./grossMarginList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f17a92e",
  null
  
)

export default component.exports